let module = angular.module('app.services.meetings-service', []);

module.service('MeetingsService', function ($uibModal, $rootScope) {
  const { account } = $rootScope;

  this.openPreferredMethod = () => {
    // Prefer chat if it's available
    if (this.openChat()) {
      return;
    }
    // Otherwise, schedule a meeting
    this.scheduleMeeting();
  };

  this.openChat = () => {
    if (window.Intercom) {
      window.Intercom('show');
      return true;
    }
    return false;
  };

  this.scheduleMeeting = (title = 'Schedule time with a live streaming expert') => {
    let url = `${HUBSPOT_MEETINGS_BASE_URL}/brian-lee/meeting-with-boxcast?embed=true`;
    if (account.isTrialing()) {
      url = `${HUBSPOT_MEETINGS_BASE_URL}/brian-lee/boxcast-live-stream-meeting?embed=true`;
    }
    $uibModal.open({
      template: require('../pages/settings/modal-schedule-meeting.html'),
      controller: require('../pages/settings/modal-schedule-meeting.js').default,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        title: () => title,
        meetingLink: () => url,
      },
    });
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/services/meetings-service.js